import storeIcon from '../../assets/shopping-bag-add.svg'

export default function StoreLinkCard() {
  return (
    <div className="card flex-col justify-between gap-sm h-full">
      <div>
        <div className="text_with_icon m-md no-margin">
          <img src={storeIcon} className="white_svg" alt="Store" />
          <span className="font-size-label bold">Site Marchand</span>
        </div>
        <p className="muted_text no-margin">Venez acheter vos jeux ici!</p>
      </div>
      <button className="button-action">Y aller</button>
    </div>
  )
}